import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';

const RegistrarGuiasdeAprendizaje = () => {
  const { codPrograma: codProgramaURL } = useParams(); // ← Renombramos para evitar conflicto
  const { guiaId } = useParams();
  const [codPrograma, setCodPrograma] = useState('');
  const navigate = useNavigate(); // Para redirigir

  useEffect(() => {
    if (codProgramaURL) {
      setCodPrograma(codProgramaURL); // ← Solo se ejecuta una vez para inicializar
    }
  }, [codProgramaURL]);

  //const [codPrograma, setCodPrograma] = useState('');
  const [nombreProyectoFormativo, setNombreProyectoFormativo] = useState('');
  const [faseProyecto, setFaseProyecto] = useState('');
  const [actividadProyectoFormativo, setActividadProyectoFormativo] = useState('');
  const [competencia, setCompetencia] = useState('');
  const [duracionGuiaHoras, setDuracionGuiaHoras] = useState('');
  const [presentacion, setPresentacion] = useState('');
  const [descripcionActividades, setDescripcionActividades] = useState('');

  // Arrays ya definidos
  const [resultadosAprendizaje, setResultadosAprendizaje] = useState([
    {
      codigo: '',
      descripcion: ''
    }
  ]);

  const [actividadesAprendizaje, setActividadesAprendizaje] = useState([
    {
      tipo: '',
      descripcionActividad: '',
      ambienteRequerido: '',
      estrategiasDidacticas: '',
      materialesFormacion: '',
      materialApoyo: '',
      evidenciasAprendizaje: '',
      instrumentosEvaluacion: '',
      duracionActividad: 0
    }
  ]);

  const [evidenciasEvaluacion, setEvidenciasEvaluacion] = useState([
    {
      faseProyectoFormativo: '',
      actividadProyectoFormativo: '',
      actividadAprendizaje: '',
      evidenciasAprendizaje: '',
      criteriosEvaluacion: '',
      tecnicasInstrumentos: ''
    }
  ]);

  const [glosario, setGlosario] = useState([
    {
      termino: '',
      definicion: ''
    }
  ]);

  const [referenciasBibliograficas, setReferenciasBibliograficas] = useState([
    {
      referencia: ''
    }
  ]);
  const [controlDocumento, setControlDocumento] = useState([
    {
      nombre: '',
      cargo: '',
      dependencia: '',
      fecha: ''
    }
  ]);
  const [controlCambios, setControlCambios] = useState([{
    nombre: "",
    cargo: "",
    dependencia: "",
    fecha: "",
    razonCambio: "",
  }]);

  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setEdit(!!guiaId);
  }, [guiaId]);





  //--------------------------------------------------------

  useEffect(() => {
    const fetchGuia = async () => {
      try {
        if (!guiaId) return;

        const response = await axios.get(`/api/programas/guias/listid/${guiaId}`);
        const data = response.data.guia;

        // Cargar datos en los estados
        setCodPrograma(data.codPrograma || '');
        setNombreProyectoFormativo(data.nombreProyectoFormativo || '');
        setFaseProyecto(data.faseProyecto || '');
        setActividadProyectoFormativo(data.actividadProyectoFormativo || '');
        setCompetencia(data.competencia || '');
        setDuracionGuiaHoras(data.duracionGuiaHoras || '');
        setPresentacion(data.presentacion || '');
        setDescripcionActividades(data.descripcionActividades || '');
        setResultadosAprendizaje(data.resultadosAprendizaje || [{ codigo: '', descripcion: '' }]);
        setActividadesAprendizaje(data.actividadesAprendizaje || [/* estructura vacía */]);
        setEvidenciasEvaluacion(data.evidenciasEvaluacion || [/* estructura vacía */]);
        setGlosario(data.glosario || [{ termino: '', definicion: '' }]);
        setReferenciasBibliograficas(data.referenciasBibliograficas || [{ referencia: '' }]);
        setControlDocumento(
          (data.controlDocumento || [{ nombre: '', cargo: '', dependencia: '', fecha: '' }]).map(item => ({
            ...item,
            fecha: item.fecha ? new Date(item.fecha).toISOString().split('T')[0] : ''
          }))
        );

        setControlCambios(
          (data.controlCambios || [{ nombre: '', cargo: '', dependencia: '', fecha: '', razonCambio: '' }]).map(item => ({
            ...item,
            fecha: item.fecha ? new Date(item.fecha).toISOString().split('T')[0] : ''
          }))
        );

      } catch (error) {
        console.error('Error al cargar la guía:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la guía de aprendizaje.',
        });
      }
    };

    fetchGuia();
  }, [guiaId]);


  // -------------------------------------------------------

  const cleanData = () => {

    setCodPrograma('');
    setNombreProyectoFormativo('');
    setFaseProyecto('');
    setActividadProyectoFormativo('');
    setCompetencia('');
    setDuracionGuiaHoras('');
    setPresentacion('');
    setDescripcionActividades('');

    setResultadosAprendizaje([
      { codigo: '', descripcion: '' }
    ]);

    setActividadesAprendizaje([
      {
        tipo: '',
        descripcionActividad: '',
        ambienteRequerido: '',
        estrategiasDidacticas: '',
        materialesFormacion: '',
        materialApoyo: '',
        evidenciasAprendizaje: '',
        instrumentosEvaluacion: '',
        duracionActividad: ''
      }
    ]);

    setEvidenciasEvaluacion([
      {
        faseProyectoFormativo: '',
        actividadProyectoFormativo: '',
        actividadAprendizaje: '',
        evidenciasAprendizaje: '',
        criteriosEvaluacion: '',
        tecnicasInstrumentos: ''
      }
    ]);

    setGlosario([
      {
        termino: '',
        definicion: ''
      }
    ]);

    setReferenciasBibliograficas([
      { referencia: '' }
    ]);

    setControlDocumento([
      {
        nombre: '',
        cargo: '',
        dependencia: '',
        fecha: ''
      }
    ]);

    setControlCambios([
      {
        nombre: '',
        cargo: '',
        dependencia: '',
        fecha: '',
        razonCambio: ''
      }
    ]);
  };


  // -------------------------------------------------------

  // Función para guardar la guía de aprendizaje
  const saveGuiaAprendizaje = async () => {
    try {

      const newGuia = {
        codPrograma,
        nombreProyectoFormativo,
        faseProyecto,
        actividadProyectoFormativo,
        competencia,
        resultadosAprendizaje,
        duracionGuiaHoras,
        presentacion,
        descripcionActividades,
        actividadesAprendizaje,
        evidenciasEvaluacion,
        glosario,
        referenciasBibliograficas,
        controlDocumento,
        controlCambios,
      };

      // Enviamos los datos al servidor
      await axios.post('/api/programas/guias/add', newGuia);
      cleanData();

      Swal.fire({
        icon: 'success',
        title: '¡Guía registrada con éxito!',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate(`/institucional/programas/`));
    } catch (error) {
      if (error.response?.data?.message) {
        return Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      }
    }
  };

  //---------------------------------------------------------

  const updateGuiaAprendizaje = async () => {


    try {
      // Verificar que guiaId esté definido
      if (!guiaId) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'El ID de la guía de aprendizaje no está definido.',
        });
        return;
      }

      const updatedGuia = {

        nombreProyectoFormativo,
        faseProyecto,
        actividadProyectoFormativo,
        competencia,
        resultadosAprendizaje,
        duracionGuiaHoras,
        presentacion,
        descripcionActividades,
        actividadesAprendizaje,
        evidenciasEvaluacion,
        glosario,
        referenciasBibliograficas,
        controlDocumento,
        controlCambios,
      };

      const { data } = await axios.put(`/api/programas/guias/update/${guiaId}`, updatedGuia);

      // Actualizar estados si usas useState para esos campos

      setNombreProyectoFormativo(updatedGuia.nombreProyectoFormativo);
      setFaseProyecto(updatedGuia.faseProyecto);
      setActividadProyectoFormativo(updatedGuia.actividadProyectoFormativo);
      setCompetencia(updatedGuia.competencia);
      setResultadosAprendizaje(updatedGuia.resultadosAprendizaje);
      setDuracionGuiaHoras(updatedGuia.duracionGuiaHoras);
      setPresentacion(updatedGuia.presentacion);
      setDescripcionActividades(updatedGuia.descripcionActividades);
      setActividadesAprendizaje(updatedGuia.actividadesAprendizaje);
      setEvidenciasEvaluacion(updatedGuia.evidenciasEvaluacion);
      setGlosario(updatedGuia.glosario);
      setReferenciasBibliograficas(updatedGuia.referenciasBibliograficas);
      setControlDocumento(updatedGuia.controlDocumento);
      setControlCambios(updatedGuia.controlCambios);

      cleanData(); // Limpiar formulario si lo necesitas

      Swal.fire({
        icon: 'success',
        title: data.message || 'Guía actualizada correctamente',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate(`/institucional/guias/listarguias/${codPrograma}`));
    } catch (error) {
      console.error('❌ Error en updateGuiaAprendizaje:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error al actualizar la guía',
      });
    }
  };




  //--------------------------------------------------------

  const actions = async (e) => {
    e.preventDefault();
    edit ? updateGuiaAprendizaje() : saveGuiaAprendizaje();
  }

  //--------------------------------------------------------

  const handleAddResultado = () => {
    setResultadosAprendizaje([...resultadosAprendizaje, { codigo: '', descripcion: '' }]);
  };

  const handleChangeResultado = (index, field, value) => {
    const newResultados = [...resultadosAprendizaje];
    newResultados[index][field] = value;
    setResultadosAprendizaje(newResultados);
  };

  // ------------------------------------------------------

  const handleAddActividad = () => {
    setActividadesAprendizaje([...actividadesAprendizaje, { tipo: '', descripcionActividad: '', ambienteRequerido: '', estrategiasDidacticas: '', materialesFormacion: '', materialApoyo: '', evidenciasAprendizaje: '', instrumentosEvaluacion: '', duracionActividad: '' }]);
  };

  const handleChangeActividad = (index, field, value) => {
    const updated = [...actividadesAprendizaje];
    updated[index][field] = value;
    setActividadesAprendizaje(updated);
  };

  // ----------------------------------------------------------

  const handleAddEvidencia = () => {
    setEvidenciasEvaluacion([...evidenciasEvaluacion, { faseProyectoFormativo: '', actividadProyectoFormativo: '', actividadAprendizaje: '', evidenciasAprendizaje: '', criteriosEvaluacion: '', tecnicasInstrumentos: '' }]);
  };

  const handleChangeEvidencia = (index, field, value) => {
    const nuevasEvidencias = [...evidenciasEvaluacion];
    nuevasEvidencias[index][field] = value;
    setEvidenciasEvaluacion(nuevasEvidencias);
  };

  // -----------------------------------------------------------

  const handleAddGlosario = () => {
    setGlosario([...glosario, { termino: '', definicion: '' }]);
  };

  const handleChangeGlosario = (index, campo, valor) => {
    const updatedGlosario = [...glosario];
    updatedGlosario[index][campo] = valor;
    setGlosario(updatedGlosario);
  };

  // -------------------------------------------------------------

  const handleAddReferencia = () => {
    setReferenciasBibliograficas([...referenciasBibliograficas, { referencia: '' }]);
  };

  const handleChangeReferencias = (index, valor) => {
    const updatedReferencias = [...referenciasBibliograficas];
    updatedReferencias[index].referencia = valor;
    setReferenciasBibliograficas(updatedReferencias);
  };


  // -------------------------------------------------------------

  const handleAddControlDocumento = () => {
    setControlDocumento([...controlDocumento, { nombre: '', cargo: '', dependencia: '', fecha: '' }]);
  };

  const handleChangeControlDocumento = (index, campo, valor) => {
    const updatedControlDocumento = [...controlDocumento];
    updatedControlDocumento[index][campo] = valor;
    setControlDocumento(updatedControlDocumento);
  };


  // ---------------------------------------------------------------

  const handleAddControlCambio = () => {
    setControlCambios([
      ...controlCambios,
      { nombre: "", cargo: "", dependencia: "", fecha: "", razonCambio: "" },
    ]);
  };

  const handleChangeControlCambios = (index, campo, valor) => {
    const updatedControlCambios = [...controlCambios];
    updatedControlCambios[index][campo] = valor;
    setControlCambios(updatedControlCambios);
  };


  const handleRemoveResultado = (indexToRemove) => {
    setResultadosAprendizaje(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleRemoveActividad = (indexToRemove) => {
    setActividadesAprendizaje(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleRemoveEvidencia = (indexToRemove) => {
    setEvidenciasEvaluacion(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleRemoveGlosario = (indexToRemove) => {
    setGlosario(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleRemoveReferencia = (indexToRemove) => {
    setReferenciasBibliograficas(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleRemoveControlDocumento = (indexToRemove) => {
    setControlDocumento(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleRemoveControlCambios = (indexToRemove) => {
    setControlCambios(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };


  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
      < div className='container-fluid mt-3' >
        <h1>Registrar Guía</h1>
      </div>

      <div className='mb-5'>

        <form onSubmit={actions}>
          <div className="container">
            <div className='border rounded p-3 mb-3'>
              <div className='row'>
                {/* Código del Programa */}
                <div className="col-12 col-md-5 mt-2">
                  <label className="form-label">Código del Programa</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Ej. 228106"
                    value={codPrograma}
                    onChange={(e) => setCodPrograma(e.target.value)}
                  />
                </div>

                {/* Fase del Proyecto */}
                <div className="col-12 col-md-3 mt-2">
                  <label className="form-label">Fase del Proyecto</label>
                  <select
                    className="form-select"
                    value={faseProyecto}
                    onChange={(e) => setFaseProyecto(e.target.value)}
                  >
                    <option value="">Seleccione una fase</option>
                    <option value="Planear">Planear</option>
                    <option value="Hacer">Hacer</option>
                    <option value="Verificar">Verificar</option>
                    <option value="Actuar">Actuar</option>
                  </select>
                </div>

                {/* Duración de la guía */}
                <div className="col-12 col-md-4 mt-2">
                  <label className="form-label">Duración de la Guía (horas)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={duracionGuiaHoras}
                    onChange={(e) => setDuracionGuiaHoras(e.target.value)}
                    min="0"
                  />
                </div>

                {/* Nombre del Proyecto Formativo */}
                <div className="col-12 mt-2">
                  <label className="form-label">Nombre del Proyecto Formativo</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nombreProyectoFormativo}
                    onChange={(e) => setNombreProyectoFormativo(e.target.value)}
                  />
                </div>

                {/* Actividad + Competencia */}
                <div className="col-12 col-md-6 mt-2">
                  <label className="form-label">Actividad Proyecto Formativo</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={actividadProyectoFormativo}
                    onChange={(e) => setActividadProyectoFormativo(e.target.value)}
                  />
                </div>

                <div className="col-12 col-md-6 mt-2">
                  <label className="form-label">Competencia</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={competencia}
                    onChange={(e) => setCompetencia(e.target.value)}
                  />
                </div>

                {/* Presentación + Descripción */}
                <div className="col-12 col-md-6 mt-2">
                  <label className="form-label">Presentación</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={presentacion}
                    onChange={(e) => setPresentacion(e.target.value)}
                  />
                </div>

                <div className="col-12 col-md-6 mt-2">
                  <label className="form-label">Descripción de Actividades</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={descripcionActividades}
                    onChange={(e) => setDescripcionActividades(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Resultados de Aprendizaje */}
          <div className="container-fluid py-1 px-0 mt-2 ">
            < div className='container-fluid mt-3' >
              <h5>Resultados de Aprendizaje</h5>
            </div>


            <div className='container mt-3'>
              <div className='border rounded p-3 mb-3'>
                {resultadosAprendizaje.map((resultado, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Código"
                        value={resultado.codigo}
                        onChange={(e) => handleChangeResultado(index, 'codigo', e.target.value)}
                      />
                    </div>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Descripción"
                        value={resultado.descripcion}
                        onChange={(e) => handleChangeResultado(index, 'descripcion', e.target.value)}
                      />
                    </div>
                    <div className="col-md-1 text-end mb-2">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{ width: "30px", height: "30px", padding: "0" }}
                        onClick={() => handleRemoveResultado(index)}
                        title="Eliminar Resultado"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex align-items-center justify-content-end mt-2">
                <h5 className="mb-0 me-2">Agregar Resultado</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddResultado}
                  title="Agregar Resultado"
                >
                  <i className="fa-solid fa-plus fa-xl text-white"></i>
                </button>
              </div>
            </div>
          </div>


          {/* Actividades de Aprendizaje */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Actividades de Aprendizaje</h5>
            </div>

            <div className="container mb-4">
              {actividadesAprendizaje.map((actividad, index) => (
                <div className="border rounded p-3 mb-4" key={index}>
                  <div className="row g-3 mb-3">
                    {/* Tipo de Actividad */}
                    <div className="col-12 col-md-4">
                      <label className="form-label fw-semibold small">Tipo de Actividad</label>
                      <select
                        className="form-select form-select-sm"
                        value={actividad.tipo}
                        onChange={(e) => handleChangeActividad(index, 'tipo', e.target.value)}
                      >
                        <option value="">Seleccione Tipo</option>
                        <option value="Reflexión inicial">Reflexión inicial</option>
                        <option value="Contextualización">Contextualización</option>
                        <option value="Apropiación">Apropiación</option>
                        <option value="Transferencia del conocimiento">Transferencia del conocimiento</option>
                      </select>
                    </div>

                    {/* Ambiente Requerido */}
                    <div className="col-12 col-md-4">
                      <label className="form-label fw-semibold small">Ambiente Requerido</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={actividad.ambienteRequerido}
                        onChange={(e) => handleChangeActividad(index, 'ambienteRequerido', e.target.value)}
                      />
                    </div>

                    {/* Duración */}
                    <div className="col-12 col-md-4">
                      <label className="form-label fw-semibold small">Duración (Horas)</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={actividad.duracionActividad}
                        onChange={(e) => handleChangeActividad(index, 'duracionActividad', e.target.value)}
                      />
                    </div>

                    {/* Instrumento de Evaluación */}
                    <div className="col-12 col-md-12">
                      <label className="form-label fw-semibold small">Instrumentos de Evaluación</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={actividad.instrumentosEvaluacion}
                        onChange={(e) => handleChangeActividad(index, 'instrumentosEvaluacion', e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Tabs */}
                  <ul className="nav nav-tabs mb-3" id={`tabs-actividad-${index}`} role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" data-bs-toggle="tab" data-bs-target={`#descripcion-${index}`} type="button" role="tab">
                        Descripción
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#estrategia-${index}`} type="button" role="tab">
                        Estrategia Didáctica
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#evidencia-${index}`} type="button" role="tab">
                        Evidencia de Aprendizaje
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#material-${index}`} type="button" role="tab">
                        Material de Apoyo
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#materialformacion-${index}`} type="button" role="tab">
                        Material de Formación
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div className="tab-pane fade show active" id={`descripcion-${index}`} role="tabpanel">
                      <textarea
                        className="form-control form-control-sm"
                        rows="5"
                        placeholder="Describa la actividad de aprendizaje"
                        value={actividad.descripcionActividad}
                        onChange={(e) => handleChangeActividad(index, 'descripcionActividad', e.target.value)}
                      />
                    </div>
                    <div className="tab-pane fade" id={`estrategia-${index}`} role="tabpanel">
                      <textarea
                        className="form-control form-control-sm"
                        rows="5"
                        placeholder="Describa la estrategia didáctica"
                        value={actividad.estrategiasDidacticas}
                        onChange={(e) => handleChangeActividad(index, 'estrategiasDidacticas', e.target.value)}
                      />
                    </div>
                    <div className="tab-pane fade" id={`evidencia-${index}`} role="tabpanel">
                      <textarea
                        className="form-control form-control-sm"
                        rows="5"
                        placeholder="Describa la evidencia de aprendizaje"
                        value={actividad.evidenciasAprendizaje}
                        onChange={(e) => handleChangeActividad(index, 'evidenciasAprendizaje', e.target.value)}
                      />
                    </div>
                    <div className="tab-pane fade" id={`material-${index}`} role="tabpanel">
                      <textarea
                        className="form-control form-control-sm"
                        rows="5"
                        placeholder="Describa el material de apoyo"
                        value={actividad.materialApoyo}
                        onChange={(e) => handleChangeActividad(index, 'materialApoyo', e.target.value)}
                      />
                    </div>

                    <div className="tab-pane fade" id={`materialformacion-${index}`} role="tabpanel">
                      <textarea
                        className="form-control form-control-sm"
                        rows="5"
                        placeholder="Describa el material de formación"
                        value={actividad.materialesFormacion}
                        onChange={(e) => handleChangeActividad(index, 'materialesFormacion', e.target.value)}
                      />
                    </div>
                    <div className=" mt-3 p-2 mb-4 position-relative" key={index}>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: '10px', right: '10px', zIndex: 10 }}
                        onClick={() => handleRemoveActividad(index)}
                        title="Eliminar Actividad"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>

                </div>
              ))}
              <div className="d-flex align-items-center justify-content-end mt-2">
              <h5 className="mb-0 me-2">Agregar Actividad</h5>
              <button
                type="button"
                className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: '40px', height: '40px' }}
                onClick={handleAddActividad}
                title="Agregar Actividad"
              >
                <i className="fa-solid fa-plus fa-xl text-white"></i>
              </button>
            </div>
            </div>
          </div>


          {/* Evidencias de Evaluación */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Evidencias de Evaluación</h5>
            </div>

            < div className="container mb-4">

              {evidenciasEvaluacion.map((evidencia, index) => (
                <div className="border rounded p-3 mb-3" key={index}>
                  <div>
                    <div className="mb-3">
                      <label className="form-label fw-semibold small text-start d-block">
                        Fase del Proyecto
                      </label>
                      <select
                        className="form-select form-select-sm"
                        value={evidencia.faseProyectoFormativo}
                        onChange={(e) => handleChangeEvidencia(index, 'faseProyectoFormativo', e.target.value)}
                      >
                        <option value="">Seleccione la fase del proyecto...</option>
                        <option value="Planear">Planear</option>
                        <option value="Hacer">Hacer</option>
                        <option value="Verificar">Verificar</option>
                        <option value="Actuar">Actuar</option>
                      </select>

                    </div>

                    {/* Tabs internas */}
                    <ul className="nav nav-tabs mb-3" id={`tabs-${index}`} role="tablist">
                      <li className="nav-item" role="presentation">
                        <button className="nav-link active" data-bs-toggle="tab" data-bs-target={`#actividadProyecto-${index}`} type="button" role="tab">
                          Actividad del Proyecto
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#actividadAprendizaje-${index}`} type="button" role="tab">
                          Actividad de Aprendizaje
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#evidencias-${index}`} type="button" role="tab">
                          Evidencias
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#criterios-${index}`} type="button" role="tab">
                          Criterios de Evaluación
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#tecnicas-${index}`} type="button" role="tab">
                          Técnicas / Instrumentos
                        </button>
                      </li>
                    </ul>

                    {/* Contenido de cada pestaña */}
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id={`actividadProyecto-${index}`} role="tabpanel">
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          placeholder="Describa la actividad del proyecto"
                          value={evidencia.actividadProyectoFormativo}
                          onChange={(e) => handleChangeEvidencia(index, 'actividadProyectoFormativo', e.target.value)}
                        ></textarea>

                      </div>
                      <div className="tab-pane fade" id={`actividadAprendizaje-${index}`} role="tabpanel">
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          placeholder="Describa la actividad de aprendizaje"
                          value={evidencia.actividadAprendizaje}
                          onChange={(e) => handleChangeEvidencia(index, 'actividadAprendizaje', e.target.value)}
                        ></textarea>

                      </div>
                      <div className="tab-pane fade" id={`evidencias-${index}`} role="tabpanel">
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          placeholder="Describa las evidencias"
                          value={evidencia.evidenciasAprendizaje}
                          onChange={(e) => handleChangeEvidencia(index, 'evidenciasAprendizaje', e.target.value)}
                        ></textarea>

                      </div>
                      <div className="tab-pane fade" id={`criterios-${index}`} role="tabpanel">
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          placeholder="Describa los criterios de evaluación"
                          value={evidencia.criteriosEvaluacion}
                          onChange={(e) => handleChangeEvidencia(index, 'criteriosEvaluacion', e.target.value)}
                        ></textarea>

                      </div>
                      <div className="tab-pane fade" id={`tecnicas-${index}`} role="tabpanel">
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          placeholder="Describa las técnicas / instrumentos"
                          value={evidencia.tecnicasInstrumentos}
                          onChange={(e) => handleChangeEvidencia(index, 'tecnicasInstrumentos', e.target.value)}
                        ></textarea>

                      </div>
                    </div>
                    <div className=" mt-3 p-2 mb-4 position-relative" key={index}>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: '10px', right: '10px', zIndex: 10 }}
                        onClick={() => handleRemoveEvidencia(index)}
                        title="Eliminar Evidencia"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                <h5 className="mb-0 me-2">Agregar Evaluación</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddEvidencia}
                  title="Agregar Resultado"
                >
                  <span className="text-white fs-2 m-0 p-0">
                    <i className="fa-solid fa-plus fa-sm" style={{ color: '#ffffff' }}></i>
                  </span>
                </button>
              </div>
            </div>
          </div>


          {/* Glosario */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Glosario</h5>
            </div>

            < div className="container mb-4">
              <div className='border rounded p-3 mb-3'>
                {glosario.map((item, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Término"
                        value={item.termino}
                        onChange={(e) => handleChangeGlosario(index, 'termino', e.target.value)}
                      />
                    </div>
                    <div className="col-md-8">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Definición"
                        value={item.definicion}
                        onChange={(e) => handleChangeGlosario(index, 'definicion', e.target.value)}
                      />
                    </div>
                    <div className="col-md-1 text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{ width: "30px", height: "30px", padding: "0" }}
                        onClick={() => handleRemoveGlosario(index)}
                        title="Eliminar Término"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                <h5 className="mb-0 me-2">Agregar Glosario</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddGlosario}
                  title="Agregar Término"
                >
                  <span className="text-white fs-2 m-0 p-0">
                    <i className="fa-solid fa-plus fa-sm" style={{ color: '#ffffff' }}></i>
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Referencias Bibliográficas */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Referencias Bibliográficas</h5>
            </div>

            < div className="container mb-4">
              <div className='border rounded p-3 mb-3'>
                {referenciasBibliograficas.map((item, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-11">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Referencia"
                        value={item.referencia}
                        onChange={(e) => handleChangeReferencias(index, e.target.value)}
                      />
                    </div>
                    <div className="col-md-1 text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{ width: "30px", height: "30px", padding: "0" }}
                        onClick={() => handleRemoveReferencia(index)}
                        title="Eliminar Referencia"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                <h5 className="mb-0 me-2">Agregar Referencia</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddReferencia}
                  title="Agregar Referencia"
                >
                  <span className="text-white fs-2 m-0 p-0">
                    <i className="fa-solid fa-plus fa-sm" style={{ color: '#ffffff' }}></i>
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Control de Documento */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Control de Documento</h5>
            </div>

            < div className="container mb-4">
              <div className='border rounded p-3 mb-3'>
                {controlDocumento.map((item, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-5">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Nombre"
                        value={item.nombre}
                        onChange={(e) => handleChangeControlDocumento(index, 'nombre', e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Cargo"
                        value={item.cargo}
                        onChange={(e) => handleChangeControlDocumento(index, 'cargo', e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Dependencia"
                        value={item.dependencia}
                        onChange={(e) => handleChangeControlDocumento(index, 'dependencia', e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="date"
                        className="form-control mb-2"
                        placeholder="Fecha"
                        value={item.fecha}
                        onChange={(e) => handleChangeControlDocumento(index, 'fecha', e.target.value)}
                      />
                    </div>
                    <div className="col-md-1 text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{ width: "30px", height: "30px", padding: "0" }}
                        onClick={() => handleRemoveControlDocumento(index)}
                        title="Eliminar"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                <h5 className="mb-0 me-2">Agregar Control</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddControlDocumento}
                  title="Agregar Control"
                >
                  <span className="text-white fs-2 m-0 p-0">
                    <i className="fa-solid fa-plus fa-sm" style={{ color: '#ffffff' }}></i>
                  </span>
                </button>
              </div>
            </div>
          </div>


          {/* Control de Cambios */}
          <div className="container-fluid py-1 px-0 ">
            < div className='container-fluid mt-3 mb-3' >
              <h5 className="mt-4">Control de Cambios</h5>
            </div>

            < div className="container mb-4">
              <div className='border rounded p-3 mb-3'>
                {controlCambios.map((item, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control mb-2"
                        name="nombre"
                        placeholder="Nombre"
                        value={item.nombre}
                        onChange={(e) => handleChangeControlCambios(index, 'nombre', e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control mb-2"
                        name="cargo"
                        placeholder="Cargo"
                        value={item.cargo}
                        onChange={(e) => handleChangeControlCambios(index, 'cargo', e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control mb-2"
                        name="dependencia"
                        placeholder="Dependencia"
                        value={item.dependencia}
                        onChange={(e) => handleChangeControlCambios(index, 'dependencia', e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="date"
                        className="form-control mb-2"
                        name="fecha"
                        placeholder="Fecha"
                        value={item.fecha}
                        onChange={(e) => handleChangeControlCambios(index, 'fecha', e.target.value)}
                      />
                    </div>
                    <div className="col-md-1 text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{ width: "30px", height: "30px", padding: "0" }}
                        onClick={() => handleRemoveControlCambios(index)}
                        title="Eliminar"
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control mb-2"
                        name="razonCambio"
                        placeholder="Razón del Cambio"
                        value={item.razonCambio}
                        onChange={(e) => handleChangeControlCambios(index, 'razonCambio', e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                <h5 className="mb-0 me-2">Agregar Cambio</h5>
                <button
                  type="button"
                  className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleAddControlCambio}
                  title="Agregar Control de Cambio"
                >
                  <span className="text-white fs-2 m-0 p-0">
                    <i className="fa-solid fa-plus fa-sm" style={{ color: '#ffffff' }}></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
       <div className='container'>
           {/* Botón de envío */}
          <div className="col-12 mt-4 mb-5">
            <div className="col-md-12 d-flex justify-content-center">
              <button type="submit" className="btn btn-success w-100">{guiaId ? 'Actualizar' : 'Enviar'}</button>
            </div>
          </div>
       </div>
        </form>

      </div>


    </div>
  );
};

export default RegistrarGuiasdeAprendizaje;
